/*
PURPOSE: Shared "WHY CORAL EXISTS" editorial section. Two-column composition:
the WHY CORAL EXISTS eyebrow label on the left, the headline statement as
display copy on the right.
USE CASES:
- Home (between Hero and HowItWorks).
- PublicArtist (between Hero and Vision).
- ArtistPayoutCollection (between Hero and Vision).
DOMAIN BOUNDARIES:
- Thin composition of editorial primitives + verbatim
  useCopy().publicPages.whyCoralExists copy. No fabricated copy ships.
- Presentational only; no data, no analytics.
*/

import React from 'react';
import { useCopy } from '../../hooks/useCopy';
import EditorialSection from './EditorialSection';
import Eyebrow from './Eyebrow';
import DisplayHeading from './DisplayHeading';

const WhyCoralSection: React.FC = () => {
  const { sectionTitle, headline } = useCopy().publicPages.whyCoralExists;

  return (
    <EditorialSection background="cream" id="why-coral">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start">
        <div className="lg:col-span-3">
          <Eyebrow>{sectionTitle}</Eyebrow>
        </div>
        <DisplayHeading as="h2" scale="heading" measure={false} className="lg:col-span-9">
          {headline}
        </DisplayHeading>
      </div>
    </EditorialSection>
  );
};

export default WhyCoralSection;
